import React from "react";

const baseButtonClasses =
  "flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-2.5 min-h-[42px] w-full rounded-lg border text-[11px] font-semibold tracking-[0.12em] uppercase transition-all leading-none";

/**
 * Reusable "View Odds" button with transparent graphite style.
 * Supports disabled state and custom className while
 * keeping consistent sizing and accessibility defaults.
 */
const ViewOddsButton = ({
  label = "VIEW ODDS",
  onClick,
  disabled = false,
  className = "",
  type = "button",
  ...buttonProps
}) => {
  const baseStyles = `${baseButtonClasses} bg-white/5 border-white/20 text-white/80 hover:bg-white/10 hover:border-white/30`;
  const disabledStyles = disabled
    ? "opacity-60 cursor-not-allowed hover:bg-white/5 hover:border-white/20"
    : "";

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${disabledStyles} ${className}`.trim()}
      aria-label={label}
      {...buttonProps}
    >
      <span>{label}</span>
    </button>
  );
};

export default ViewOddsButton;
